import { ResponsivePie } from "@nivo/pie";
import { Empty } from "antd";
import { Loader } from "../loader";
interface ICreateDashboard {
  datas?: any;
  loader: boolean;
}
export const PieChart1: React.FC<ICreateDashboard> = ({ datas, loader }) => {
  const data = [
    {
      id: " Order",
      label: "Order",
      value: datas?.total_orders_count,
      color: " hsl(#26CDEB)",
    },
    {
      id: "Sales Lead",
      label: "Sales Leads",
      value: datas?.sales_lead_count,
      color: "hsl(211, 70%, 50%)",
    },
    {
      id: "NPD",
      label: "NPD",
      value: datas?.npd_count,
      color: "hsl(149, 70%, 50%)",
    },
    {
      id: "Quotation",
      label: "Quotation",
      value: datas?.quotation_count,
      color: "hsl(296, 70%, 50%)",
    },
  ];
  const colorArray = [" #26CDEB ", "#B574E0", "#1ECD2F", "#E53A2F"];
  return (
    <>
      {loader ? (
        <div className="flex w-full justify-center items-center h-full">
          <Loader />
        </div>
      ) : data ? (
        <ResponsivePie
          data={data}
          margin={{ top: 60, right: 80, bottom: 15, left: 80 }}
          innerRadius={0.5}
          padAngle={0.7}
          cornerRadius={3}
          colors={colorArray}
          activeOuterRadiusOffset={8}
          borderWidth={1}
          borderColor={{
            from: "color",
            modifiers: [["darker", 0.2]],
          }}
          arcLinkLabelsSkipAngle={10}
          arcLinkLabelsTextColor="#333333"
          arcLinkLabelsThickness={2}
          arcLinkLabelsColor={{ from: "color" }}
          arcLabelsSkipAngle={10}
          arcLabelsTextColor={{
            from: "color",
            modifiers: [["darker", 2]],
          }}
          defs={[
            {
              id: "dots",
              type: "patternDots",
              background: "inherit",
              color: "rgba(255, 255, 255, 0.3)",
              size: 4,
              padding: 1,
              stagger: true,
            },
            {
              id: "lines",
              type: "patternLines",
              background: "inherit",
              color: "rgba(255, 255, 255, 0.3)",
              rotation: -45,
              lineWidth: 6,
              spacing: 10,
            },
          ]}
          fill={[
            {
              match: {
                id: "ruby",
              },
              id: "dots",
            },
            {
              match: {
                id: "c",
              },
              id: "dots",
            },
            {
              match: {
                id: "go",
              },
              id: "dots",
            },
            {
              match: {
                id: "python",
              },
              id: "dots",
            },
            {
              match: {
                id: "scala",
              },
              id: "lines",
            },
            {
              match: {
                id: "lisp",
              },
              id: "lines",
            },
            {
              match: {
                id: "elixir",
              },
              id: "lines",
            },
            {
              match: {
                id: "javascript",
              },
              id: "lines",
            },
          ]}
          legends={[
            {
              anchor: "top",
              direction: "row",
              justify: false,
              translateX: 0,
              translateY: 0,
              itemsSpacing: 0,
              itemWidth: 100,
              itemHeight: -100,
              itemTextColor: "#999",
              itemDirection: "left-to-right",
              itemOpacity: 1,
              symbolSize: 18,
              symbolShape: "square",
              effects: [
                {
                  on: "hover",
                  style: {
                    itemTextColor: "#000",
                  },
                },
              ],
            },
          ]}
        />
      ) : (
        <Empty className="w-full h-full flex justify-center items-center flex-col" />
      )}
    </>
  );
};
